<template>
    <div class="mt-[-160px]">
        <div class="absolute bg-gray-900 top-0 left-0 right-0 h-[80px] z-10"></div>
        <div class="flex justify-between h-[760px] sm:h-[620px] lg:h-[690px]" id="home">
            <div class="w-full lg:w-2/5 h-full sm:mt-[-5px] md:mt-[-20px] lg:mt-4">
                <iframe src="https://tamep.transclicksolutions.com/flights/flight-search" class="h-full w-full sm:h-[710px] lg:h-[760px] scale-75 rounded-3xl">
                    Tu navegador no soporta iframes.
                </iframe>
            </div>
            <div class="lg:mt-36 w-3/5 hidden lg:block">
                <FullItinerary id="itinerario"/>
            </div>
        </div>
        <VideoTam />
        <TheItinerary id="itinerario"/>
        <CitySelector id="ofertas" />
        <NewDestinations id="proximos" />
        <OurDirections id="oficinas" />
    </div>
</template>

<script>
import VideoTam from './VideoTam.vue';
import CitySelector from './CitySelector.vue';
import NewDestinations from './NewDestinations.vue';
import OurDirections from './OurDirections.vue';
import TheItinerary from './TheItinerary.vue';
import FullItinerary from './FullItinerary.vue';

export default {
    name: 'HomePrincipal',
    components: {
        VideoTam,
        CitySelector,
        NewDestinations,
        OurDirections,
        TheItinerary,
        FullItinerary,
    },
};
</script>